export const AVAILABLE_COUNTRY_CODES = ['US', 'CA', 'AU'];
